import React from 'react';

import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';

import { isExpectedAutohighlightsError } from './isExpectedAutohighlightsError.ts';

type AutohighlightsErrorDisplayProps = {
	error: Error;
};

export const AutohighlightsErrorDisplay = ({
	error,
}: AutohighlightsErrorDisplayProps): React.JSX.Element | null => {
	if (isExpectedAutohighlightsError(error)) {
		markErrorAsHandled(error);
		return null;
	}

	return <ErrorDisplay error={error} />;
};
